import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import { FaFacebookF, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../assets/logo.png";

export default function Footer() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <footer className="minimalist-corporate-footer" data-aos="fade-up">
      <div className="container-fluid px-4 px-md-5">
        
        {/* UPPER ROW: Brand Metadata, Inline Links & Socials Container */}
        <div className="footer-upper-alignment-belt">
          
          {/* Brand Column Block */}
          <div className="footer-compact-identity" onClick={() => appContext.navTo({ item: "home" })}>
            <img src={logo} alt="Blessing Management Consultancy Logo" className="footer-mini-logo" />
            <span className="footer-brand-title">
              Blessing <span className="title-gold-accent">Consultancy</span>
            </span>
          </div>

          {/* Inline Navigation Menu Strip */}
          <nav className="footer-inline-navigation-bar">
            <button onClick={() => appContext.navTo({ item: "home" })} className="footer-nav-link-node">Home</button>
            <button onClick={() => appContext.navTo({ item: "about", subItem: "overview" })} className="footer-nav-link-node">About</button>
            <button onClick={() => appContext.navTo({ item: "services" })} className="footer-nav-link-node">Services</button>
            <button onClick={() => appContext.navTo({ item: "contact" })} className="footer-nav-link-node">Contact</button>
          </nav>

          {/* Minimalist Rounded Icon Social Hub */}
          <div className="footer-social-cluster-tray">
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="footer-social-node" aria-label="LinkedIn Profile">
              <FaLinkedinIn />
            </a>
            <a href="https://x.com" target="_blank" rel="noreferrer" className="footer-social-node" aria-label="X Profile">
              <FaXTwitter />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="footer-social-node" aria-label="Facebook Profile">
              <FaFacebookF />
            </a>
            <a href="https://whatsapp.com" target="_blank" rel="noreferrer" className="footer-social-node" aria-label="WhatsApp Channel">
              <FaWhatsapp />
            </a>
          </div>

        </div>

        {/* Horizontal Split Line Boundary */}
        <div className="footer-thin-divider-line" />

        {/* LOWER ROW: Copyright Metadata & Premium Developer Signature */}
        <div className="footer-lower-metadata-belt">
          <p className="footer-copyright-caption">
            &copy; {getCurrentYear()} Blessing Management Consultancy. All rights reserved.
          </p>
          
          <div className="footer-signature-wrapper">
            <span className="signature-static-label">Website developed by</span>
            <a 
              href="https://werenium.com" 
              target="_blank" 
              rel="noreferrer" 
              className="werenium-premium-signature-link"
            >
              <span className="signature-text-reveal">werenium</span>
              <span className="signature-animated-underline" />
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}